import { render, staticRenderFns } from "./OverviewCard.vue?vue&type=template&id=6038f680"
import script from "./OverviewCard.vue?vue&type=script&lang=ts"
export * from "./OverviewCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports